import { Link } from "react-router-dom";
import { Panel } from "../../components/ui";
import SupportTicketList from "components/SupportTickets/SupportTicketList";
import { partnerQueryKeys } from "../../api/queryKeys";
import { fetchSupportTickets } from "../../api/endpoints/support";

const ticketLink = (ticket) => `/partner/help/tickets/${ticket.id}`;

/**
 * Specific issues get a ticket each, with its own thread. Open tickets come first and page on
 * their own so they never sink below old history; everything else is in the full list.
 */
const SupportTicketsPanel = () => (
  <div className="space-y-4">
    <Panel
      title="Open support tickets"
      action={
        <Link
          to="/partner/help/tickets/new"
          className="rounded-lg bg-teal-600 px-3 py-1.5 text-xs font-semibold text-white no-underline"
        >
          New support ticket
        </Link>
      }
    >
      <SupportTicketList
        queryKey={partnerQueryKeys.supportList("OPEN")}
        fetchPage={fetchSupportTickets}
        params={{ status: "OPEN" }}
        pageSize={5}
        linkTo={ticketLink}
        emptyText="No open tickets. Open one when you need help with a specific issue."
      />
    </Panel>
    <Panel title="All support tickets">
      <SupportTicketList
        queryKey={partnerQueryKeys.supportList("ALL")}
        fetchPage={fetchSupportTickets}
        params={{ status: "ALL" }}
        pageSize={10}
        linkTo={ticketLink}
        emptyText="You have not opened any support tickets yet."
      />
    </Panel>
  </div>
);

export default SupportTicketsPanel;
